import ErrorPageLayout from "@/shared/ui/components/errorPages/ErrorPageLayout";
import Text from "@/shared/ui/refresh-components/texts/Text";
import { SvgAlertCircle } from "@opal/icons";

export default function Error() {
  return (
    <ErrorPageLayout>
      <div className="flex flex-row items-center gap-2">
        <Text as="p" headingH2>
          We encountered an issue
        </Text>
        <SvgAlertCircle className="w-[1.5rem] h-[1.5rem] stroke-text-04" />
      </div>

      <Text as="p" text03>
        It seems there was a problem loading your workspace settings. This could
        be due to a configuration issue or incomplete setup.
      </Text>

      <Text as="p" text03>
        If you&apos;re an admin, please review the configuration steps in your
        deployment documentation. If you&apos;re a user, please contact your
        admin for assistance.
      </Text>

      <Text as="p" text03>
        Need help? Please contact your system administrator for support.
      </Text>
    </ErrorPageLayout>
  );
}
